import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-card-building-icon",
  "use": "svg-icon-card-building-icon-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-card-building-icon\"><path d=\"M10.5 6H6.992A1.997 1.997 0 005 7.992v7.016C5 16.1 5.892 17 6.992 17h7.016A1.997 1.997 0 0016 15.008V12h-1.5v2.503c0 .55-.453.997-.997.997H7.497c-.55 0-.997-.453-.997-.997V8.497c0-.55.453-.997.997-.997H10.5V6zm1.5-.5h5v5h-5v-5z\" fill=\"#717B7F\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol